import { Button } from "@mui/material";
import React from "react";

export default function ActionButton(props) {
  const { children, onClick, disableHover } = props;
  let style = disableHover ? {} : { ":hover": { background: 'none' } }

  return <Button sx={style} onClick={onClick}>{children}</Button>;
}
